class LoginUtils {

  checkLoginStatus() {
    const timeOutTime = localStorage.getItem('timeOutTime');
    if (timeOutTime) return new Date().getTime() < timeOutTime;  
  }
  getSessionTimeoutInMilliseconds(){
    return 110 * 60 * 1000;
  }
}

const loginUtils = new LoginUtils();
export default loginUtils;